import {Injectable}                          from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment}                         from '../../environments/environment';
import {APIService}                          from 'src/app/API.service';

import OneSignal                                                    from 'onesignal-cordova-plugin';
import {DataStore}                                                  from "@aws-amplify/datastore";
import {Notification, PermissionType, SupportRequest, Ticket, User} from "../../models";


const headers = new Headers();
headers.append('Content-Type', 'application/x-www-form-urlencoded');


@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private baseUrl = 'https://onesignal.com/api/v1';

    private app_id = environment.onSignal.id;
    private rest_api_key = environment.onSignal.apiKey;

    httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'}),
    };

    constructor(
            private http: HttpClient,
            private apiService: APIService,
    ) {
    }

    notify(userDeviceId, msg, sendAfterDateTime?, redirectUrl = null) {
        const message: any = {
            app_id: this.app_id,
            include_player_ids: [userDeviceId],
            contents: {en: msg},
            attachments: {
                data: {
                    url: redirectUrl
                },
                app_url: redirectUrl,

            }
        };
        if (sendAfterDateTime) {
            message.send_after = sendAfterDateTime;
        }
        const url = this.baseUrl + '/notifications';
        return this.http.post(url, message).toPromise();

    }

    notifyByMail(subbject, msg, mail, sendAfterDateTime?) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + this.rest_api_key,
            }),
        };
        const message: any = {
            app_id: this.app_id,
            email: {vale: mail},
            include_email_tokens: [mail],
            email_subject: subbject,
            email_body: msg,
            // email_from_name: environment.onSignal.email.emailFromName,
            //  email_from_address: environment.onSignal.email.emailFromAdress

        };
        if (sendAfterDateTime) {
            message.send_after = sendAfterDateTime;
        }
        const url = this.baseUrl + '/notifications';
        return this.http.post(url, message, httpOptions);
    }


    notifyAll(msg: string) {
        const message = {
            app_id: this.app_id,
            include_player_ids: undefined,
            contents: {en: msg},
            send_after: null,
        };

        
        const params = new HttpParams();

        const url = this.baseUrl + '/notifications';
        this.http.post(url, message).subscribe(value => {
            
        });
    }

    scheduleAppointmentNotification(appointment: any, msg: string, now: string) {
        if (!appointment.User?.device_id) {
            return;
        }
        this.notify(appointment.User.device_id, msg, now).then((value: any) => {

            if (value) {


            }

        });
        this.notifyByMail(appointment.User.email, msg, now).subscribe((value: any) => {
            console.log(value);

        });
    }


    sendNewAppointmentNotification(userDeviceId, msg: string, sendAfterDateTime?: string, appointmentId?: string) {
        if (!userDeviceId) {
            return;
        }
        const message: any = {
            app_id: this.app_id,
            include_player_ids: [userDeviceId],
            contents: {en: msg},
        };
        if (sendAfterDateTime) {
            message.send_after = sendAfterDateTime;
        }
        
        const params = new HttpParams();

        const url = this.baseUrl + '/notifications';
        this.http.post(url, message).subscribe((value: any) => {

            if (appointmentId) {
            }

        });
    }

    sendCancelAppointmentNotification(appointment: any, msgToOperators?: string) {
        //value.notificationId, value.branch.admin.device_id, x
        const params = new HttpParams();
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + this.rest_api_key,
            }),
        };
        if (appointment.notificationId) {
            const url = this.baseUrl + '/notifications/' + appointment.notificationId + '?app_id=' + this.app_id;
            this.http.delete(url, httpOptions).subscribe(value => {
                /* if (appointmentId) {this.apiService.UpdateAppointment({id: appointmentId, notificationId: value.id});}*/

            });
        }
        if (appointment.notificationEmailId) {
            const url = this.baseUrl + '/notifications/' + appointment.notificationEmailId + '?app_id=' + this.app_id;
            this.http.delete(url, httpOptions).subscribe(value => {
                /* if (appointmentId) {this.apiService.UpdateAppointment({id: appointmentId, notificationId: value.id});}*/

            });
        }
        if (msgToOperators) {
            //this.notifyOperators(msgToOperators);
        }

    }

    sendScheduldNotification(endPoint, data = {}, dateTime) {
        
        const params = new HttpParams();

        const url = this.baseUrl + '/notifications';
        this.http.post(url, data).subscribe(value => {
            console.log('inviato aonesignal', value);
        });

    }

    async notifyAdmin(msg, url?, sendAfter?) {
        // this.messages.push(newMessageObject);
        try {
            let admins = await DataStore.query(User, condition => condition.permessions('eq', PermissionType.ADMINISTRATOR))
            admins.forEach(async u => {
                await this.notify(u.device_id, msg, sendAfter, url);
            })
            await DataStore.save(new Notification({
                        url: url,
                        msg: msg,
                        isAdmin: true,
                        isSeen: false,
                        isOperator: false,
                        createdAt: new Date().toISOString()

                    })
            );

        } catch (e) {
            
        }
    }

    async notifyCLient(msg, clientId, url = null, sendAfter = null) {
        let user = await DataStore.query(User, clientId)

        await this.notify(user.device_id, msg, sendAfter, url);
        await DataStore.save(new Notification({
                    msg: msg,
                    userId: clientId,
                    isAdmin: false,
                    isSeen: false,
                    isOperator: false,
                    createdAt: new Date().toISOString(),


                })
        );
    }
    async notifyCommercial(msg, clientId, url = null, sendAfter = null) {
        let user = await DataStore.query(User, clientId)

        await this.notify(user.device_id, msg, sendAfter, url);
        await DataStore.save(new Notification({
                    msg: msg,
                    userId: clientId,
                    isAdmin: false,
                    isSeen: false,
                    isOperator: true,
                    createdAt: new Date().toISOString(),


                })
        );
    }


}
